export default __webpack_public_path__ + "static/media/Hair_5_M_C4.f76a3720.svg";